import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import Unicon from '@/components/General/Unicon';
import DropdownMenu from '@/components/General/DropdownMenu';
import { StyleSheet } from 'react-native-unistyles';
import { parseTimeFrame } from '@/utils/dater';

const FolderRow = ({ folder, onPress, onLongPress, isSelected, onSelect, viewMode = 'list', onRename, onDelete }) => {

  const menu = (
    <DropdownMenu
      triggerComponent={
        <View testID={`folder-menu-${folder.id}`} style={styles.menuTrigger}>
          <Unicon name="ellipsis-vertical" size={20} colorVariant="textSecondary" />
        </View>
      }
      options={[
        {
          name: 'Edit',
          icon: { web: 'pencil', ios: 'pencil', android: 'edit' },
          onSelect: () => onRename?.(folder),
        },
        {
          name: 'Delete',
          icon: { web: 'trash', ios: 'trash', android: 'delete' },
          destructive: true,
          onSelect: () => onDelete?.(folder),
        },
      ]}
    />
  );

  if (viewMode === 'grid') {
    return (
      <TouchableOpacity
        testID={`folder-row-${folder.id}`}
        onPress={() => onPress?.(folder)}
        onLongPress={() => onLongPress?.(folder)}
        style={[styles.gridCard, isSelected && styles.gridCardSelected]}
      >
        <View style={styles.gridMenuWrap}>{menu}</View>
        <Unicon name="folder" size={32} colorVariant="primary" library="material" />
        <Text style={styles.gridName} numberOfLines={2}>{folder.name}</Text>
      </TouchableOpacity>
    );
  }

  return (
    <View
      testID={`folder-row-${folder.id}`}
      style={[styles.row, isSelected && styles.rowSelected]}
    >
      <TouchableOpacity testID={`folder-checkbox-${folder.id}`} onPress={() => onSelect?.(folder)} style={styles.checkbox}>
        <Unicon
          name={isSelected ? 'checkbox-marked' : 'checkbox-blank-outline'}
          size={24}
          colorVariant={isSelected ? 'primary' : 'textSecondary'}
          library="material"
        />
      </TouchableOpacity>

      <TouchableOpacity testID={`folder-pressable-${folder.id}`} style={styles.rowPressable} onPress={() => onPress?.(folder)} onLongPress={() => onLongPress?.(folder)}>
        <Unicon name="folder" size={24} colorVariant="primary" library="material" />
    
        <View style={styles.nameWrap}>
          <Text style={styles.name} numberOfLines={1}>{folder.name}</Text>
          <Text style={styles.meta}>{parseTimeFrame(folder.createdAt)}</Text>
        </View>
      </TouchableOpacity>

      <View style={styles.menuWrap}>
        {menu}
      </View>
    </View>
  );
};

const styles = StyleSheet.create(({ colors }) => ({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  rowSelected: {
    backgroundColor: colors.primary + '20',
  },
  checkbox: {
    marginRight: 12,
  },
  rowPressable: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  menuWrap: {
    alignSelf: 'flex-end',
  },
  nameWrap: {
    flex: 1,
    marginLeft: 12,
  },
  name: {
    fontSize: 14,
    fontWeight: '500',
    color: colors.text,
  },
  meta: {
    fontSize: 10,
    fontWeight: '400',
    color: colors.textSecondary,
  },
  menuTrigger: {
    padding: 4,
    borderRadius: 6,
    _web: { cursor: 'pointer', _hover: { opacity: 0.7 } },
  },
  gridCard: {
    flex: 1,
    margin: 6,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.surface,
    padding: 12,
    alignItems: 'center',
    gap: 8,
    minWidth: 100,
    maxWidth: 200,
  },
  gridCardSelected: {
    backgroundColor: colors.primary + '20',
  },
  gridMenuWrap: {
    position: 'absolute',
    top: 6,
    right: 6,
  },
  gridName: {
    fontSize: 12,
    fontWeight: '500',
    textAlign: 'center',
    color: colors.text,
  },
}));

export default FolderRow;
